import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * A flex child that actually scrolls internally instead of growing its
 * ancestor. `min-h-0` overrides the flex default of `min-height: auto`,
 * which otherwise stops this element from ever shrinking to its flex-basis
 * once content exceeds the available space — see
 * docs/superpowers/specs/2026-07-19-flex-scroll-min-h-0-audit-design.md
 * for the full root-cause writeup. Must be used inside a bounded
 * `flex flex-col` ancestor (fixed height, `max-h-[XXvh]`, or `h-screen`) —
 * ScrollPanel only solves the flex-shrink half of the problem, not the
 * "something must bound the ancestor" half.
 */
const ScrollPanel = React.forwardRef(({ className, children, ...props }, ref) => (
  <div ref={ref} className={cn("flex-1 min-h-0 overflow-y-auto", className)} {...props}>
    {children}
  </div>
))
ScrollPanel.displayName = "ScrollPanel"

export { ScrollPanel }
